import { render, staticRenderFns } from "./ClassifyAccountAttributes.vue?vue&type=template&id=513788f8&scoped=true"
import script from "./ClassifyAccountAttributes.vue?vue&type=script&lang=js"
export * from "./ClassifyAccountAttributes.vue?vue&type=script&lang=js"
import style0 from "./ClassifyAccountAttributes.vue?vue&type=style&index=0&id=513788f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513788f8",
  null
  
)

export default component.exports